<template>
	<el-container>
		<div class="colhead">
			<h2 class="header_h2">分院信息管理</h2>
		</div>
		<el-header>
			<el-button type="primary" style="margin:10px 5px 0px 10px;float: left;" @click="baonewAdd">新增</el-button>
			<el-input v-model="select_word" placeholder="分院名称过滤查找"
				style="display:inline-block;width:350px;float: left;"></el-input>
		
		</el-header>
		<el-main>
			
			<el-table border ref="multipleTable" tooltip-effect="dark" :data="data.slice((currentPage-1)*pagesize,currentPage*pagesize)">
				<el-table-column prop="isvalid" label="启用" width="50px">
					<template slot-scope="scope">
						<label v-if='scope.row.isvalid=="0"'>禁用</label>
						<label v-if='scope.row.isvalid=="1"'>启用</label>
					</template>
				</el-table-column>
				<el-table-column prop="branch_img" label="logo" width="220px">
					<template slot-scope="scope5">
						<div>
							<a href="javascript:;" class="uploadfile">上传logo
								<input type="file" name="" id="" @change="getFile($event, scope5.row)" :accept="myaccept">
							</a>
							<img style="max-width:100px ; width:auto ;height: auto;" :src='"/img"+ scope5.row.branch_img' alt="">
						</div>

					</template>
				</el-table-column>

				<el-table-column prop="branch_name" label="分院名称" width="300px"></el-table-column>
				<el-table-column prop="branch_type" label="分院类型">
					<template slot-scope="scope1">
						<label v-if='scope1.row.branch_type=="0"'>体检中心</label>
						<label v-if='scope1.row.branch_type=="1"'>医院</label>
					</template>
				</el-table-column>
				<el-table-column prop="branch_level" label="信誉度"></el-table-column>
				<el-table-column prop="corp_id" label="企业" width="120px">
					<template slot-scope="scope2">
						<div v-for="item in CorpData">
							<label v-if='scope2.row.corp_id==item.corp_id'>{{item.corp_name}}</label>
						</div>

					</template>
				</el-table-column>
				<el-table-column prop="city_id" label="所属城市" width="100px">
					<template slot-scope="scope3">
						<div v-for="item in CityList">
							<label v-if='scope3.row.city_id==item.id'>{{item.name}}</label>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="80px" fixed="right">
					<template slot-scope="scope4">
						<el-button @click="handleEdit(scope4.$index, scope4.row)" icon="el-icon-edit" type="text" size="small">编辑</el-button>
						
						<!-- <input class="file" type="file" @change="getFile($event, scope4.row)" title="上传logo" accept=".jpg,.png,.bmp,.gif"></input> -->
					</template>
				</el-table-column>
			</el-table>
			<!-- </el-container> -->
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						 :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="data.length"></el-pagination>
					</div>
				</template>
			</el-footer>
		</el-main>
		<!-- 修改个人信息 -->
		<el-dialog title="修改信息" :visible.sync="bao1edit">
			<el-form :model="EditInfo" ref="EditInfo" label-width="100px">
				<el-form-item label="启用">
					<el-switch v-model="EditInfo.isvalid" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="分院名称">
					<el-input v-model="EditInfo.branch_name"></el-input>
				</el-form-item>
				<el-form-item label="分院类型">
					<el-select v-model="EditInfo.branch_type" placeholder="请选择" style="width: 100%;">
						<el-option v-for="item in emBranchType" :label="item.key" :value="item.value">{{ item.key }}</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属企业">
					<el-select style=" width: 100%;  height:30px;" v-model="EditInfo.corp_id">
						<el-option v-for="item in CorpData" :label="item.corp_name" :value="item.corp_id" placeholder="请选择">
							{{ item.corp_name }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属城市">
					<el-select style=" width: 100%;  height:30px;" v-model="EditInfo.city_id" placeholder="请选择">
						<el-option v-for="item in CityList" :label="item.name" :value="item.id">
							{{ item.name }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="信誉度">
					<el-input type='number' v-model="EditInfo.branch_level"></el-input>
				</el-form-item>
				<el-form-item label="分院地址">
					<el-input v-model="EditInfo.branch_address"></el-input>
				</el-form-item>
				<el-form-item label="联系电话">
					<el-input v-model="EditInfo.branch_tel"></el-input>
				</el-form-item>
				<el-form-item label="分院描述">
					<el-input v-model="EditInfo.branch_desc"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="EditInfo.memo"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1editSure">确定</el-button>
					<el-button @click.native="bao1edit = false">取消</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>

		<!-- ----新增个人信息---- -->
		<el-dialog title="新增分院信息" :visible.sync="bao1newadd">
			<el-form :model="AddInfo" ref="AddInfo" label-width="100px">
				<el-form-item label="启用">
					<el-switch v-model="AddInfo.isvalid" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="分院名称">
					<el-input v-model="AddInfo.branch_name"></el-input>
				</el-form-item>
				<el-form-item label="分院类型">
					<el-select v-model="AddInfo.branch_type" placeholder="请选择" style="width: 100%;">
						<el-option v-for="item in emBranchType" :label="item.key" :value="item.value">{{ item.key }}</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="企业">
					<el-select style=" width: 100%;  height:30px;" v-model="AddInfo.corp_id">
						<el-option v-for="item in CorpData" :value="item.corp_id" :label="item.corp_name" placeholder="请选择">
							{{ item.corp_name }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属城市">
					<el-select style=" width: 100%;  height:30px;" v-model="AddInfo.city_id" placeholder="请选择">
						<el-option v-for="item in CityList" :value="item.id" :label="item.name">
							{{ item.name }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="信誉度">
					<el-input v-model="AddInfo.branch_level"></el-input>
				</el-form-item>
				<el-form-item label="分院地址">
					<el-input v-model="AddInfo.branch_address"></el-input>
				</el-form-item>
				<el-form-item label="联系电话">
					<el-input v-model="AddInfo.branch_tel"></el-input>
				</el-form-item>
				<el-form-item label="分院描述">
					<el-input v-model="AddInfo.branch_desc"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="AddInfo.memo"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
					<el-button @click.native="bao1newadd = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-container>
</template>



<script>
	import enums from '../../commontools/enums.js'
	import Branch from '../../apifunction/Branch.js'
	import corp from '../../apifunction/Corp.js'
	import city from '../../apifunction/City.js'
	export default {
		data() {
			return {
				myaccept:'.jpg,.png,.bmp,.gif',
				BranchData: [],
				CorpData: [],
				CityList: [],
				emBranchType: enums.CorpType,
				chk: true,
				currentPage: 1,
				pagesize: 10,
				bao1edit: false,
				bao1newadd: false,
				idx: null,
				imgArr: [],
				imgShow: [],
				//   通过姓名查询
				select_word: "",
				EditInfo: {
					branch_id: '',
					branch_name: '',
					branch_type: '',
					branch_level: 0,
					isvalid: '1',
					branch_address: '',
					branch_tel:'',
					branch_desc:'',
					corp_id: '',
					city_id: '',
					memo: '',
					branch_img: ''
				},
				AddInfo: {
					branch_id: '',
					branch_name: '',
					branch_type: '',
					branch_level: 0,
					isvalid: '1',
					branch_address: '',
					branch_tel:'',
					branch_desc:'',
					corp_id: '',
					city_id: '',
					memo: '',
					branch_img: ''
				}
			};
		},
		mounted() {
			this.getAllCorp();
			this.getAllCity();
			this.getAllBranch();
		},
		methods: {
			getFile(event, row) {
				//alert(JSON.stringify(event.target.files))
				var file = event.target.files;

				// 上传类型判断
				var imgName = file[0].name;
				var idx = imgName.lastIndexOf(".");
				if (idx != -1) {
					var ext = imgName.substr(idx + 1).toUpperCase();
					ext = ext.toLowerCase();
					if (ext != 'jpg' && ext != 'png' && ext != 'bmp' && ext != 'gif') {
						alert('图片格式不支持！')
					} else {

						let param = new FormData(); //创建form对象
						param.append('file', file[0]); //通过append向form对象添加数据
						//param.append('branch_id', row.branch_id);
						Branch.UploadBranchImg(param, row.branch_id)
							.then(res => {
								let ent = JSON.parse(JSON.stringify(res.data))
								if (ent.Flag == 'success') {
									row.branch_img = ent.Data;
									this.$message.info('上传成功!');

								} else
									this.$message.info(ent.Msg);
							})
					}
				} else {

				}
			},
			getAllCorp() {
				corp.GetAllCorp()
					.then(res => {
						//alert(JSON.stringify(res.data))
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.CorpData = JSON.parse(ent.Data);


						} else
							this.$message.info(ent.Msg);
					})
				// this.BranchData = enums.BranchData;
			},
			//   得到所有的数据---------------
			getAllBranch() {
				Branch.GetAllBranch()
					.then(res => {

						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							//alert(JSON.stringify(res.data))
							// if(ent.Data!="null")
							// {
								if(ent.Data!='null')
							this.BranchData = JSON.parse(ent.Data);

							// }
							// alert(JSON.stringify(this.BranchData))

						} else
							this.$message.info(ent.Msg);
					})
				// this.BranchData = enums.BranchData;
			},
			getAllCity() {
				city.GetCityByLevel(2)
					.then(res => {
						//alert(JSON.stringify(res.data))
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.CityList = JSON.parse(ent.Data);
						} else
							this.$message.info(ent.Msg);
					})
			},
			// 分页------------------------
			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},

			// 操作界面 ----------- 编辑-----通过改变数据并且驱动视图更新$set方法
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;

				this.EditInfo = {
					branch_id: row.branch_id,
					branch_name: row.branch_name,
					branch_type: row.branch_type,
					branch_level: row.branch_level,
					isvalid: row.isvalid,
					branch_address: row.branch_address,
					corp_id: row.corp_id,
					city_id: row.city_id,
					branch_tel:row.branch_tel,
					branch_desc:row.branch_desc,
					memo: row.memo,
					branch_img: row.branch_img
				};
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				Branch.EditBranch(this.EditInfo)
					.then(res => {

						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.BranchData.splice(this.idx, 1, this.EditInfo)
							this.bao1edit = false;
							this.$message.success("修改成功");

						} else
							this.$message.info(ent.Msg);
					})

			},
			// 新增按钮-----
			baonewAdd() {
				this.bao1newadd = true;
				this.AddInfo.branch_name = '';
				this.AddInfo.branch_type = '0';
				this.AddInfo.branch_level = 1;
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				//this.$refs.AddInfo 这个数据上有一个validate方法,这个方法可以判断数据是否存在
				if (this.AddInfo.branch_name == '') {
					this.$message.success("分院名称不能为空！");
					return;
				}
				this.AddInfo.branch_id = this.CommonFun.NewGuid();
				Branch.AddBranch(this.AddInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.BranchData.unshift(this.AddInfo);
							this.bao1newadd = false;
							this.$message.success("新增成功");

						} else
							this.$message.info(ent.Msg);
					})
			}
		},
		computed: {
			data() {
				return this.BranchData.filter(item => {
					if (item.branch_name.indexOf(this.select_word) > -1) {
						return item;
					}
				});
			}
		}
	};
</script>


<style scoped>

</style>
